import {sendRequest} from '@js/utils';

const countOrganizationsLang = 'Количество образовательных организаций';

export function initChart(settings, $chartContainer) {
    const defaultSettings = {
        chart: {
            animation: false,
            height: 300,
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
        },
        title: {
            text: '',
        },
        subtitle: {
            text: '',
        },
        yAxis: {
            title: false,
        },
        tooltip: false,
        legend: {
            enabled: false,
        },
        plotOptions: {
            series: {
                animation: false,
            },
        },
        navigation: {
            buttonOptions: {
                enabled: false,
            },
        },
    };
    const {Highcharts} = window;
    const chartSettings = $.extend(true, defaultSettings, settings);
    new Highcharts.Chart(chartSettings, (() => {
        $chartContainer.show();
    }));
}

export function leagueChartPie($chartRenderContainer, chartData) {
    if (chartData.length === 0) {
        $chartRenderContainer.html('Нет данных для построения графика');
        return true;
    }
    const data = [];
    for (const index in chartData) {
        const item = chartData[index];
        const league = parseInt(item.league, 10);
        const selected = league === 1;
        const sliced = league === 1;
        data.push({
            name: item.league_name,
            y: Number.parseFloat(parseFloat(item.percentage)
                .toFixed(2)),
            sliced,
            selected,
            countOrganizations: item.count,
        });
    }
    const $chartContainer = $('#chart-pie-container').closest('.chart-container');
    const series = [{
        name: 'Распределение организаций',
        colorByPoint: true,
        allowPointSelect: true,
        data,
    }];
    const settings = {
        chart: {
            type: 'pie',
            renderTo: 'chart-pie-container',
        },
        tooltip: {
            pointFormat: `<b>${countOrganizationsLang}:</b> {point.countOrganizations} ({point.percentage:.1f}%)`,
        },
        plotOptions: {
            pie: {
                allowPointSelect: false,
                cursor: 'pointer',
                dataLabels: {
                    enabled: true,
                    format: '<b>{point.name}</b>:<br>{point.countOrganizations} ({point.percentage:.1f} %)',
                    style: {
                        color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black',
                    },
                },
                showInLegend: true,
            },
        },
        series,
    };
    initChart(settings, $chartContainer);
}

export function zoneChartColumn($chartRenderContainer, chartData, colors) {
    if (chartData.length === 0) {
        $chartRenderContainer.html('Нет данных для построения графика');
        return true;
    }
    const data = [];
    for (const index in chartData) {
        const item = chartData[index];
        const zoneIndex = parseInt(item.zone_index, 10);
        const color = colors[zoneIndex];
        data.push({
            name: item.name,
            y: Number.parseFloat(parseFloat(item.percentage).toFixed(2)),
            color,
            countOrganizations: item.count,
        });
    }
    const series = [{
        name: 'Распределение лиг по зонам',
        type: 'column',
        allowPointSelect: true,
        data,
        dataLabels: {
            enabled: true,
        },
    }];
    const $chartContainer = $chartRenderContainer.closest('.chart-container');
    const settings = {
        chart: {
            type: 'bar',
            renderTo: 'chart-column-container',
        },
        xAxis: {
            categories: [1, 2, 3, 4],
            crosshair: true,
        },
        yAxis: {
            min: 0,
            title: {
                text: '',
            },
        },
        tooltip: {
            pointFormat: `<b>${countOrganizationsLang}:</b> {point.countOrganizations} ({point.y:.1f}%)`,
        },
        plotOptions: {
            column: {
                allowPointSelect: true,
                pointPadding: 0.2,
                cursor: 'pointer',
                dataLabels: {
                    enabled: true,
                    format: '<b>{point.name}:</b> {point.countOrganizations} ({point.y:.1f}%)',
                    style: {
                        color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || '#312f2f',
                    },
                },
                showInLegend: true,
            },
        },
        series,
    };
    initChart(settings, $chartContainer);
}

export function initCharts() {
    const $chartsWrapper = $('.charts-wrapper');
    if ($chartsWrapper.length) {
        $chartsWrapper.show();
        const $chartColumnRenderContainer = $('#chart-column-container');
        const $chartRenderContainer = $('#chart-pie-container');
        const pageParam = $(window.location)
            .attr('href')
            .split('?')
            .splice(1, 2);
        const chartErrorsHandler = function () {
            $chartColumnRenderContainer.html('Произошла ошибка при построении графика');
            $chartRenderContainer.html('Произошла ошибка при построении графика');
        };
        if ($('.errors-container').length) {
            chartErrorsHandler();
        } else {
            sendRequest('get', `/ratings/national/nacionalnyj-agregirovannyj-rejting/getChartData?${pageParam}`, {}, (res) => {
                if (typeof res.success !== 'undefined' && res.success) {
                    const drawCharts = function () {
                        if (typeof res.column.data !== 'undefined') {
                            zoneChartColumn($chartColumnRenderContainer, res.column.data, res.column.colors);
                        }
                        if (typeof res.pieData !== 'undefined') {
                            leagueChartPie($chartRenderContainer, res.pieData);
                        }
                    };
                    if ($chartColumnRenderContainer.is(':hidden')) {
                        const intervalId = setInterval(() => {
                            if (!$chartColumnRenderContainer.is(':hidden')) {
                                clearInterval(intervalId);
                                drawCharts();
                            }
                        }, 250);
                    } else {
                        drawCharts();
                    }
                } else {
                    chartErrorsHandler();
                }
            });
        }
    }
}
